import { render, staticRenderFns } from "./ClassCreatorTab.vue?vue&type=template&id=b77bab6e&"
import script from "./ClassCreatorTab.vue?vue&type=script&lang=js&"
export * from "./ClassCreatorTab.vue?vue&type=script&lang=js&"
import style0 from "./ClassCreatorTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports